import { Request } from "../../../infrastructure/request";
import { ITracker } from "../../interfaces/tracker.interface";
import { Microservice } from "../../model/microservice";
import { HtmlRepository } from "../../repositories/html-repository";
import { BaseChainableBobComponent } from "../base-chainable-bob-component";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";
import { IProcessable } from "../pipeline/processable.interface";

export class HtmlLoaderComponent extends BaseChainableBobComponent<Microservice> implements IProcessable<Microservice> {

	private htmlRepository: HtmlRepository;

	constructor(htmlRepository: HtmlRepository, tracker: ITracker) {

		super(tracker);
		this.htmlRepository = htmlRepository;
	}

	public async process(input: Microservice) {

		let html = input.manifest.html;

		// If the HTML from the manifest is a URL rather than a snippet, we will fetch the HTML remotely
		if (this.isUrl(html)) {

			html = await this.htmlRepository.get(new Request(html));
		}

		input.setHtml(html);

		return await this.next.process(input);
	}

	public isUrl(html) {

		const foundUrls = html.match(/^http(s)?:\/\/\w+(\.\w+)*(:[\s\S]+)?\/?(\/[.\w]*)*$/);

		return foundUrls !== null && foundUrls.length > 0;
	}
}
